import { gql } from '@apollo/client';

export const DELETE_EXHIBITION = gql`
  mutation DeleteExhibition($slug: String!) {
    success: deleteExhibition(slug: $slug)
  }
`;
